// Hostname-based feature flags.
//
// Both the Preview and Production environments deploy from the same Git repo
// and therefore share the same .env file.
//
// Calibration was previously hidden on the production host while in progress.
// It's now feature-complete and enabled everywhere, including production.

const PRODUCTION_HOSTS = ['erp.abokspring.in'];

export const isProductionHost = () =>
  PRODUCTION_HOSTS.includes(window.location.hostname);

export const isCalibrationEnabled = () => true;
